import api from '@/utils/api';

/**
 * Update CompanyTemplate
 * @param {string} id Company id
 * @param {string} templateId Template id
 * @param {object} data - The CompanyTemplate data
 * @returns {Promise}
 */
const updateCompanyTemplateApi = (id, templateId, data) =>
  api.patch(`/company/${id}/template/${templateId}`, data);

export default updateCompanyTemplateApi;
